<template>
  <v-row justify="center" v-if="programa && estudiante">
    <v-dialog v-model="dialog" scrollable :overlay="false" max-width="800px" transition="dialog-transition">
      <v-card>
        <v-card-text>
          <div id="html">
            <div class="mb-0 pb-0 text-center">
              <img :src="getimgkardex(programa.universidad)" class="img-responsive" />
            </div>
            <v-card-title primary-title>
              <h3 class="text-center upper--text title-print text-black">{{ programa.nombre_compuesto }}</h3>
            </v-card-title>
            <div class="pl-2 te">
              <p class="my-0 py-1 upper--text">
                {{ posgraduante_str }}: {{ estudiante.nombres }} {{ estudiante.pri_apellido }}
                {{ estudiante.seg_apellido }}
              </p>
              <p class="my-0 py-1 upper--text">CARNET DE IDENTIDAD: {{ estudiante.num_doc }}</p>
              <p class="my-0 py-1 upper--text">FECHA DE ELABORACIÓN: {{ date }}</p>
              <br />
              <table class="item-table upper--text">
                <thead>
                  <th class="item-th">Concepto</th>
                  <th class="item-th">N° de Cuota</th>
                  <th class="item-th">Fecha Vencimiento</th>
                  <th class="item-th">Asignacion mensual</th>
                  <th class="item-th">Saldo</th>
                  <th class="item-th">Plazo de Pago</th>
                </thead>
                <tbody class="">
                  <tr class="item-tr" v-for="item in plan_pagos" :key="item.id">
                    <td class="item-td">{{ item.concepto_pago }}</td>
                    <td class="item-td text-center">{{ item.nro_cuota }}</td>
                    <td class="item-td text-center" style="font-size: 0.8em">{{ item.fecha_pago }}</td>
                    <td class="item-td text-center">{{ item.monto }}</td>
                    <td class="item-td text-center">{{ item.saldo }}</td>
                    <td class="item-td text-center" style="font-size: 0.8em">{{ item.plazo_pago }}</td>
                    <!-- <td class="item-td">{{ item.saldo == 0 ? 'Cancelado' : item.saldo == item.monto ? formatDate(item.fecha_pago) : 'Pago Parcial' }}</td> -->
                  </tr>
                </tbody>
              </table>

              <br />
              <br />
              <table class="item-table upper--text">
             
                <tbody class="">
                  <tr class="item-tr" v-for="item in cobros_programa" :key="item.id">
                    <td class="item-td">{{ item.concepto_pago.nombre }}</td>
                    <td class="item-td text-center">{{ fixed(item.monto) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br />
            <v-divider></v-divider>
            <div class="italic--text te">
              <p v-if="asesor" class="my-0 y-0">
                {{ asesor.sexo == 'M' ? 'Licenciado' : 'Licenciada' }} : {{ asesor.nombres }} {{ asesor.pri_apellido }}
                {{ asesor.seg_apellido }}
              </p>
              <p class="my-0 y-0">Departamento Administrativo - Contable {{ sede.nombre }}</p>
              <!-- <p class="my-0 y-0">Telf. oficina {{ sede.telefono_fijo ? sede.telefono_fijo : '.................' }}</p> -->
              <p class="my-0 y-0">
                Celular :
                {{ sede.telefono1 ? sede.telefono1 : '.................' }}
                {{ sede.telefono2 ? `, ${sede.telefono2}` : '' }}
              </p>
              <p class="my-0 y-0">Dirección: {{ sede.direccion ? ` ${sede.direccion}` : '..............' }}</p>
              <p class="my-0 y-0 upper--text" v-if="sede.ciudad">
                {{ sede.ciudad.nombre ? ` ${sede.ciudad.nombre} - BOLIVIA` : '' }}
              </p>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="$store.state.isonlyread" color="red lighten-2" rounded @click="printRecibo">
            <v-icon class="mr-1"> mdi-printer</v-icon> Imprimir o pdf <v-icon class="ml-1"> mdi-file-pdf</v-icon>
          </v-btn>
          <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
            Cerrar <v-icon> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import { Printd } from 'printd';
  import moment from 'moment';
  import { mapState } from 'vuex';
  import xaxios from '@/xaxios';
import gql from 'graphql-tag';
import { concepto_ids_orden } from '@/views/upi/planes/utils'

  moment.locale('es');
  export default {
    data() {
      return {
        cssText: null,
        firma_path: process.env.VUE_APP_URL_BG_FIRMA_USER,
        api_rest: process.env.VUE_APP_API_REST,
        dialog: false,
        estudiante: null,
        programa: null,
        asesor: null,
        cobros_programa: [],
        plan_pagos: [],
        date: null,
        totales: [], 
        posgraduante_str:'POSGRADUANTE',
      };
    },
    watch: {
      dialog(val) {
        val || this.closeDialog();
      },
    },
    computed: {
      ...mapState({
        sede: (state) => state.modsede.items.find((t) => t.id == state.CARGO.sede.id),
        // programa: (state) => state.programa.value,
      }),
    },
    methods: {
      showThisView(estudiante, plan_programa, plan_pagos, programa, idinscripcion) {
        window.console.log('KARDEX::', JSON.stringify(plan_pagos, null, 4));
        //window.console.log('COBRSO::', JSON.stringify(plan_pagos, null, 4));
        if (!plan_programa.cobros_programa) plan_programa.cobros_programa = [];
        this.programa = programa;
        this.cobros_programa = plan_programa.cobros_programa.map((cobro) => ({ ...cobro, monto: 0 }));
        this.getkardex(idinscripcion);
        this.getSede();
        const vue = this;
        this.dialog = true;
        this.date = moment().format('DD MMMM [del] YYYY');
        this.estudiante = estudiante;
        plan_pagos.forEach((x) => {
          const conceptoPagoId = x.concepto_pago_id || (x.concepto_pago && x.concepto_pago.id);
          const monto = Number(x.monto ?? x.total) || 0;
          const concepto = vue.cobros_programa.find((c) => c.concepto_pago.id == conceptoPagoId);
          if (concepto) concepto.monto += monto;
        });
        if(
          this.programa.nombre_compuesto.includes('LICENCIATURA') || 
          this.programa.nombre_compuesto.includes('TÉCNICO')
        ){
          this.posgraduante_str = 'ESTUDIANTE'
        }else{
          this.posgraduante_str = 'POSGRADUANTE'
        }
        /*this.plan_pagos = plan_pagos.map((plan) => ({
        ...plan,
        monto: plan.monto.toFixed(2),
        descuento: plan.descuento.toFixed(2),
        saldo: plan.saldo.toFixed(2),
      }));*/
      },
      fixed(m) {
        if (!m) return '';
        return m.toFixed(2);
      },
      getkardex(idinscripcion) {
        const vue = this;
        const url = `${process.env.VUE_APP_API_REST}/api/v1/inscripcion/${idinscripcion}/plan-pago/kardex`;
        xaxios.get(url).then(({ data }) => {
          window.console.log('KARDEX:', data.data);
          const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        
          if(unidad == 15){
            const prioridad = new Map(
              concepto_ids_orden.map((id, index) => [id, index])
            );
            /* data.data.sort((a, b) => {
              return (prioridad.get(a.concepto_pago_id) ?? Infinity)
                  - (prioridad.get(b.concepto_pago_id) ?? Infinity);
            }); */
            data.data.sort((a, b) => {
              const prioridadA = prioridad.get(a.concepto_pago_id) ?? Infinity;
              const prioridadB = prioridad.get(b.concepto_pago_id) ?? Infinity;

              // Primero ordena por concepto_pago_id (según tu mapa de prioridad)
              if (prioridadA !== prioridadB) {
                return prioridadA - prioridadB;
              }

              // Si tienen la misma prioridad, ordena por nro_cuota
              return a.nro_cuota - b.nro_cuota;
            });

            this.cobros_programa.sort((a, b) => {
              const prioridadA = prioridad.get(a.concepto_pago.id) ?? Infinity;
              const prioridadB = prioridad.get(b.concepto_pago.id) ?? Infinity;
              return prioridadA - prioridadB;
            })
          }
          
          vue.plan_pagos = data.data.map((plan) => ({
            ...plan,
            monto: (Number(plan.total) || 0).toFixed(2),
            //descuento: plan.descuento.toFixed(2),
            saldo: (Number(plan.saldo) || 0).toFixed(2),
          }));
        });
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.slice(0, 10).split('-');
        return `${day}/${month}/${year}`;
      },
      printRecibo() {
        const d = new Printd();
        d.print(document.getElementById('html'), [this.cssText]);
      },
      getSede() {
        let id = this.$store.state.CARGO.sede.id;
        const sql = gql`query{getSede(id: ${id}) { id nombre nombre_recibo modelo_recibo direccion telefono1 ${''}}}`;
        this.$apollo.query({ query: sql }).then(({ data }) => {
          // this.sede = data.getSede;
          this.sede.modelo_recibo = process.env.VUE_APP_URL_BG_RECIBO_SEDE + data.getSede.modelo_recibo;
        });
      },
      closeDialog() {
        this.dialog = false;
        this.$nextTick(() => {
          this.cobros_programa = [];
          this.plan_pagos = [];
          this.estudiante = null;
          this.programa = null;
          // this.asesor = null;
          this.date = null;
        });
      },
      getimgkardex(u) {
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        // window.console.log('kardexxxxxx', unidad, u);
        if (unidad == 1) {
          if (!u) return 'img/bg_kardex.png';
          else if (u.id == 128) return 'img/bg_kardexubj.png';
          else if (u.id == 2) return 'img/bg_kardexuajms.png';
          else return 'img/bg_kardex.png';
        } else if (unidad == 2) {
          if (!u) return 'img/bg_kardex_cca.webp';
          else if (u.id == 128) return 'img/bg_kardexubj_cca.webp';
          else if (u.id == 2) return 'img/bg_kardexuajms_cca.webp';
          else if (u.id == 9) return 'img/bg_kardexxx_cca.webp';
          else return 'img/bg_kardex_cca.webp';
        } else if (unidad == 3) {
          return 'img/bg_kardex_ck.webp';
        } else if (unidad == 10) {
          if (!u) return 'img/bg_kardex_dbs.webp';
          else if (u.id == 2) return 'img/bg_kardex_dbsuajms.webp';
          else if (u.id == 9) return 'img/bg_kardex_dbsxx.webp';
          return 'img/bg_kardex_dbs.webp';
        }else if (unidad == 14) {          
          return this.sede.modelo_recibo;
        }else if (unidad == 15) {          
          return this.sede.modelo_recibo;
        }
        return 'img/bg_kardex.png';
      },
    },
    mounted() {
      this.asesor = this.$store.state.DATA_USER;
      this.cssText = `
      table {
        border-collapse: collapse;
        border-spacing: 0;
        
    }

      .v-card__subtitle,
      .v-card__text {
          font-size: .875rem;
          font-weight: 400;
          line-height: 1.375rem;
          letter-spacing: .0071428571em;
      }

      .theme--light.v-card .v-card__subtitle,
      .theme--light.v-card>.v-card__text {
          color: rgba(0, 0, 0, .6);
      }
      .pl-3{
        padding-left: 3em;
      }
      .pl-2{
        padding-left: 2em;
      }

      .mb-0 {
          margin-bottom: 0 !important;
      }

      .pb-0 {
          padding-bottom: 0 !important;
      }

      .container,
      .container-fluid {
          padding-left: 15px;
          margin-right: auto;
          margin-left: auto;
          
      }


      .col-3 {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 25%;
          flex: 0 0 25%;
          max-width: 25%;
      }

      .carousel-inner>.item>a>img,
      .carousel-inner>.item>img,
      .img-responsive,
      .thumbnail a>img,
      .thumbnail>img {
          display: block;
          max-width: 100%;
          max-height: auto;
      }
      .v-divider

      img {
          border-style: none;
          border: 0;
          vertical-align: middle;
      }

      .col-9 {
          -webkit-box-flex: 0;
          -ms-flex: 0 0 75%;
          flex: 0 0 75%;
          max-width: 75%;
      }

      .my-0 {
          margin-top: 0 !important;
          margin-bottom: 0 !important;
      }

      .py-0 {
          padding-top: 0 !important;
          padding-bottom: 0 !important;
      }

      .theme--light, .v-divider {
          border-color: rgba(0, 0, 0, .12);
          margin: 2em;
      }
      pa-1{
        padding: 1em;
      }

      .pt-1 {
          padding-top: 4px !important;
      }

      .row {
          --bs-gutter-x: 1.5rem;
          --bs-gutter-y: 0;
          display: flex;
          flex-wrap: wrap;
          margin-top: calc(var(--bs-gutter-y) * -1);
          margin-right: calc(var(--bs-gutter-x) / -2);
          margin-left: calc(var(--bs-gutter-x) / -2);
      }

      .row>* {
          box-sizing: border-box;
          flex-shrink: 0;
          width: 100%;
          max-width: 100%;
          padding-right: calc(var(--bs-gutter-x) / 2);
          padding-left: calc(var(--bs-gutter-x) / 2);
          margin-top: var(--bs-gutter-y);
      }

      .col {
          flex: 1 0 0%;
      }

      .col,
      .col-1,
      .col-2,
      .col-3,
      .col-4,
      .col-5,
      .col-6,
      .col-7,
      .col-8,
      .col-9,
      .col-10,
      .col-11,
      .col-12,
      .col-auto,
      .col-lg,
      .col-lg-1,
      .col-lg-2,
      .col-lg-3,
      .col-lg-4,
      .col-lg-5,
      .col-lg-6,
      .col-lg-7,
      .col-lg-8,
      .col-lg-9,
      .col-lg-10,
      .col-lg-11,
      .col-lg-12,
      .col-lg-auto,
      .col-md,
      .col-md-1,
      .col-md-2,
      .col-md-3,
      .col-md-4,
      .col-md-5,
      .col-md-6,
      .col-md-7,
      .col-md-8,
      .col-md-9,
      .col-md-10,
      .col-md-11,
      .col-md-12,
      .col-md-auto,
      .col-sm,
      .col-sm-1,
      .col-sm-2,
      .col-sm-3,
      .col-sm-4,
      .col-sm-5,
      .col-sm-6,
      .col-sm-7,
      .col-sm-8,
      .col-sm-9,
      .col-sm-10,
      .col-sm-11,
      .col-sm-12,
      .col-sm-auto,
      .col-xl,
      .col-xl-1,
      .col-xl-2,
      .col-xl-3,
      .col-xl-4,
      .col-xl-5,
      .col-xl-6,
      .col-xl-7,
      .col-xl-8,
      .col-xl-9,
      .col-xl-10,
      .col-xl-11,
      .col-xl-12,
      .col-xl-auto {
          width: 100%;
          padding: 12px;
      }
      .item-table {
        border: 1px solid silver;
        width: 95%;
      }
      .item-td,
      .item-th {
        padding: 5px;
        border: 1px solid silver;
        
      }
      .item-tr {
        height: 10px;
        
      }

      .page-break {
        page-break-before: always;
      }
      .upper--text {
        text-transform: uppercase;
      }
      .italic--text {
        font-style: italic;
        padding-left: 3em;
      }

      .text-right {
          text-align: right !important;
      }

      .pa-2 {
          padding: 2em !important;
      }
      td {
          vertical-align: middle !important;
      }

      .text-center {
          text-align: center !important;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        font-weight: 500;
        line-height: 1.2;
        color: #317eac;
      }

      .item-td,
      .item-th {
        /* padding: 5px; */
        border: 1px solid silver;
        font-size: 0.2em important!;
      }
      .item-tr {
        height: 10px;
        
      }

      .page-break {
        page-break-before: always;
      }
      .text-black {
        color: black;
        font-weight: bold;
        
      }
      .te{
        font-size: 0.92rem;
      }`;
    },
  };
</script>

<style>
  .item-table {
    border: 1px solid silver;
    width: 95%;
  }
  .item-td,
  .item-th {
    padding: 5px;
    border: 1px solid silver;
  }
  .item-tr {
    height: 10px;
  }

  .page-break {
    page-break-before: always;
  }
  .upper--text {
    text-transform: uppercase;
  }
  .italic--text {
    font-style: italic;
    padding-left: 2em;
  }
  .text-black {
    color: black;
  } 
</style>
